const translations = {
  RegulationsTitle: 'Regulamin aplikacji "client.speedwash.pl"',
  RegulationsFooter: 'Regulamin',
  BackToApplication: 'Wróć do aplikacji',
};

export default translations;
